import '../assets/styles/AboutUs.scss';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface Props {
  paragraph: string
}

const MarkdownComponent = ({ paragraph }: Props) => {

  return (
     <div className='aboutUs-container'>
    <article className="prose prose-slate max-w-none">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {paragraph}
      </ReactMarkdown>
    </article>
    </div>
  )
}

export default MarkdownComponent